module.exports = __webpack_public_path__ + "static/media/Tile Image - Sero Formal.3da9169e.png";